
import { useContext } from '@nuxtjs/composition-api';
import useRoamingPrices from '~/composable/useRoaminPrices';

export default {
  setup () {
    const { app } = useContext()
    const {
      isSyria,
      isDenmarkToDenmark,
      prices,
      localPrices,
      fromCountryModel,
      paymentTypeModel,
      toCountryModel,
      onCountryChange,
      onPaymentTypeChange
    } = useRoamingPrices(app)
    return {
      isSyria,
      isDenmarkToDenmark,
      prices,
      localPrices,
      fromCountryModel,
      paymentTypeModel,
      toCountryModel,
      onCountryChange,
      onPaymentTypeChange
    }
  }
}
